import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (location.state?.user) return children;
  if (loading || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FBF8F3]">
        <p className="font-display text-2xl italic text-[#5C534B]">Un attimo...</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/accedi" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};
